module.exports = __webpack_public_path__ + "img/f2.5bc35e2b.png";